import React, { useState } from 'react';
import { MessageOutlined } from '@ant-design/icons'; // Asegúrate de tener Ant Design o cambia el ícono

import './scss/SupportWidget.scss'; // o App.scss si lo metes ahí

function SupportWidget() {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <div className="support-widget-icon" onClick={() => setVisible(!visible)}>
        <MessageOutlined />
      </div>

      {visible && (
        <div className="support-widget-box bounce-in">
          <h3>💡 Need <code>IT</code> Support?</h3>
          <p>
            If you experience any issue or have a question,<br />
            don’t hesitate to contact us. <br />
          <a
            href={`mailto:it@solucinde.com?subject=Solucinde - Need support in STS page&body=Hi, I have an issue in my STS form app from support.solucinde.com`}
            className="email-button"
          >
            📧 Send Email to IT
          </a>
          </p>
  
          <button onClick={() => setVisible(false)}>Close</button>
        </div>
      )}
    </>
  );
}

export default SupportWidget;
